import styled, { css } from "styled-components";

const headerHeight = "60px";
const closePanelWidth = "50px";
const mobileBreakpoint = "768px";
const desktopNavWidth = "311px";

export const StyledHeader = styled.header`
  border-right: 1px solid #cdd5df;
  position: fixed;
  top: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: ${headerHeight};
  padding: 16px 16px 20px 16px;
  gap: 12px;
  z-index: 10;
  @media (min-width: ${mobileBreakpoint}) {
    width: ${desktopNavWidth};
  }
`;

export const StyledNav = styled.nav<{ $isOpen: boolean }>`
  border-right: 1px solid #cdd5df;
  z-index: 10;
  overflow: hidden;
  position: fixed;
  background-color: #fff;
  display: ${(props) => (props.$isOpen ? "flex" : "none")};
  flex-direction: column;
  width: calc(100% - ${closePanelWidth});
  height: calc(100% - ${headerHeight});
  top: ${headerHeight};
  left: 0;

  @media (min-width: ${mobileBreakpoint}) {
    width: ${desktopNavWidth};
    height: calc(100% - ${headerHeight});
  }

  ul {
    padding: 0px 8px;
  }

  ul ul {
    padding: 0px;
  }

  & li {
    list-style-type: none;
    display: flex;
    flex-direction: column;
  }
  ul ul li a {
    padding-left: 39px;
  }

  div {
    &::-webkit-scrollbar {
      width: 0;
      background: transparent;
    }
  }
  svg path {
    stroke: rgba(154, 164, 178, 1);
  }
`;

export const StyledBottomSection = styled.div`
  margin-top: auto;
  padding: 0px 0px 16px 0px;
`;

export const StyledIconButton = styled.button<{ $IconColor?: string }>`
  all: unset;
  height: fit-content;
  cursor: pointer;
  display: flex;
  &:focus-visible {
    outline: 2px solid #6b6b6bff;
    border-radius: 4px;
  }

  svg path {
    stroke: ${(props) =>
      props.$IconColor ?? "rgba(154, 164, 178, 1)"} !important;
  }
`;

export const StyledClosePannel = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: ${closePanelWidth};
  background-color: #0d121c;
  text-align: center;
  padding-top: 20px;
  display: flex;
  justify-content: center;
`;

const baseNavItem = css<{ $isActive?: boolean }>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid #000;
  }
  margin: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  /* Text md/Semibold */
  color: #364152;
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  border-radius: 6px;

  &:hover,
  &:focus-visible {
    background: #f3f5f6;
    color: #202939;
  }

  ${(props) =>
    props.$isActive &&
    `
    background: #f3f5f6;
    color: #202939;
  `}

  span {
    text-wrap: auto;
  }
`;

export const StyledNavItemLink = styled.a<{ $isActive?: boolean }>`
  ${baseNavItem}
  &:focus {
    color: #202939;
  }
`;

export const StyledNavItemButton = styled.button<{ $isActive?: boolean }>`
  ${baseNavItem}
`;
